import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/UnderstandingTest/CaikumaElated.svg?webp'
import _imports_1 from '@/assets/svg/UnderstandingTest/CaikumaSad.svg?webp'


const _withScopeId = n => (_pushScopeId("data-v-1d8b63d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "\n      理解度テスト\n    ", -1))
const _hoisted_3 = { class: "progress" }
const _hoisted_4 = { class: "bar" }
const _hoisted_5 = { class: "step" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = {
  key: 0,
  class: "question-container"
}
const _hoisted_8 = { class: "question" }
const _hoisted_9 = { class: "teacher-image" }
const _hoisted_10 = {
  key: 1,
  class: "answer-container"
}
const _hoisted_11 = { class: "question" }
const _hoisted_12 = { class: "answer" }
const _hoisted_13 = { class: "result" }
const _hoisted_14 = { class: "correctness" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "image"
}, null, -1))
const _hoisted_16 = { class: "title" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label correct" }, "正解", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "おめでとうございます！", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "CaikumaSad"
  })
], -1))
const _hoisted_20 = { class: "title" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label incorrect" }, "不正解", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "もう一回答えてください", -1))
const _hoisted_23 = { class: "explanation" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "【解説】", -1))
const _hoisted_25 = { class: "highlight" }
const _hoisted_26 = { class: "normal" }
const _hoisted_27 = { class: "footer bg-white" }

import { ref, computed, onBeforeMount } from "vue";
import { useRoute } from "vue-router";
import CaikumaTeacher from "@/assets/svg/UnderstandingTest/CaikumaTeacher.svg?component";
import Step1 from "@/assets/svg/UnderstandingTest/Step1.svg?component";
import Step2 from "@/assets/svg/UnderstandingTest/Step2.svg?component";
import Step3 from "@/assets/svg/UnderstandingTest/Step3.svg?component";
import Correct from "@/assets/svg/UnderstandingTest/Correct.svg?component";
import Incorrect from "@/assets/svg/UnderstandingTest/Incorrect.svg?component";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { useCustomRouter } from "@/utils/router";

type PageType = "question" | "answer";
type Answer = "YES" | "NO";
type Question = {
  question: string;
  answer: Answer;
  explanation: {
    highlight: string;
    normal: string;
  };
};


export default /*#__PURE__*/_defineComponent({
  __name: 'UnderstandingTestQuestion',
  setup(__props) {

const allQuestions: Question[] = [
  {
    question: "お仕事申込み完了後、事業所側から連絡があり、面接が行われる",
    answer: "NO",
    explanation: {
      highlight: "申込み完了後は、その時点で「確定」となります",
      normal: "申込み前に内容をよく確認してから、申込みましょう！"
    }
  },
  {
    question: "無断欠勤をすると、一時的に利用停止になる",
    answer: "YES",
    explanation: {
      highlight:
        "いかなる理由があっても、無断欠勤をすると「一時的に利用停止」となります",
      normal: "出勤できなくなった時点で、必ずキャンセルしましょう！"
    }
  },
  {
    question:
      "「当日」と「前日」のキャンセルでは、信用スコアの減る点数は同じである",
    answer: "NO",
    explanation: {
      highlight: "前日より当日キャンセルの方が、信用スコアは大きく減点されます",
      normal:
        "また、直前キャンセルが多いと応募できるお仕事が限定されてしまいます。"
    }
  },
  {
    question: "キャンセル申請は取り消すことができない",
    answer: "YES",
    explanation: {
      highlight:
        "一度アプリよりキャンセルの申請をすると、取り消すことができません",
      normal: "キャンセル申請される際は、注意しましょう！"
    }
  },
  {
    question: "勤務開始時間を過ぎると、アプリよりキャンセル申請ができない",
    answer: "YES",
    explanation: {
      highlight: "勤務開始時間を過ぎるとアプリよりキャンセル申請ができません",
      normal:
        "必ず勤務開始前までにアプリからキャンセル申請をしましょう！電話連絡だけでは、キャンセル未申請のままです。事務局での手続き完了まで画面操作ができなくなります。"
    }
  },
  {
    question: "応募条件を満たしていないと、キャンセルになる場合がある",
    answer: "YES",
    explanation: {
      highlight: "応募条件は事業所ごとに異なります",
      normal: "必ず仕事詳細の応募条件を確認し、応募するようにしましょう！"
    }
  },
  {
    question: "キャンセルにより信用スコアが0ptになった場合、永久に回復されない",
    answer: "NO",
    explanation: {
      highlight: "信用スコア0ptになった場合、一定期間を経て回復します",
      normal: "詳細はFAQをご確認ください。"
    }
  },
  {
    question:
      "勤務日前日または当日のお仕事のキャンセルの場合でも事業所にメッセージで伝えれば良い",
    answer: "NO",
    explanation: {
      highlight:
        "勤務日前日または当日のキャンセルは、事業所への電話連絡が必須です",
      normal: "電話連絡とアプリ上の申請を実施しましょう！"
    }
  },
  {
    question: "お仕事確定後に事業所と事前連絡ができる",
    answer: "YES",
    explanation: {
      highlight: "応募先の事業所とメッセージにて連絡することができます",
      normal:
        "事業所からのメッセージ受信時にはプッシュ通知にてお知らせいたします。"
    }
  }
];

const route = useRoute();
const { replaceIgnoreError } = useCustomRouter();
const targetQuestions = ref<Question[]>([]);
const currentStep = ref(1);
const currentPageType = ref<PageType>("question");
const currentAnswer = ref<Answer | null>(null);
const isCorrect = ref<boolean | null>(null);

const orderId = computed(() => Number(route.params["orderId"]));
const workTimeOptionId = computed(() =>
  Number(route.params["workTimeOptionId"])
);

const currentQuestion = computed(
  () => targetQuestions.value[currentStep.value - 1]
);
const showsClickNextButton = computed(() => {
  return currentPageType.value === "answer" && isCorrect.value === true;
});
const showsBackToQuestionButton = computed(() => {
  return currentPageType.value === "answer" && isCorrect.value === false;
});
const showsYesNoButtons = computed(() => {
  return currentPageType.value === "question";
});

onBeforeMount(() => {
  targetQuestions.value = pickUpQuestions();
});

// ランダムに3問取得
function pickUpQuestions() {
  return allQuestions.sort(() => Math.random() - 0.5).slice(0, 3);
}

async function onClickNext() {
  if (currentStep.value < 3) {
    currentStep.value = currentStep.value + 1;
    currentPageType.value = "question";
    currentAnswer.value = null;
    isCorrect.value = null;
    window.scrollTo(0, 0);
  } else {
    await replaceIgnoreError({
      name: "OrdersUnderstandingTestFinish",
      params: {
        orderId: orderId.value.toString(),
        workTimeOptionId: workTimeOptionId.value.toString()
      }
    });
  }
}

function onClickBackToQuestion() {
  currentPageType.value = "question";
  currentAnswer.value = null;
  isCorrect.value = null;
}

function onClickYesNo(answer: Answer) {
  currentPageType.value = "answer";
  currentAnswer.value = answer;
  isCorrect.value = currentQuestion.value.answer === answer;
  window.scrollTo(0, 0);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createTextVNode(),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (currentStep.value === 1)
          ? (_openBlock(), _createBlock(_unref(Step1), { key: 0 }))
          : (currentStep.value === 2)
            ? (_openBlock(), _createBlock(_unref(Step2), { key: 1 }))
            : (currentStep.value === 3)
              ? (_openBlock(), _createBlock(_unref(Step3), { key: 2 }))
              : _createCommentVNode("", true)
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_5, "第" + _toDisplayString(currentStep.value) + "問", 1)
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_6, [
      (currentPageType.value === 'question')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(currentQuestion.value.question), 1),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(CaikumaTeacher))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(currentQuestion.value.question), 1),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_12, _toDisplayString(currentAnswer.value), 1),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                (isCorrect.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_15,
                      _createTextVNode(),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_unref(Correct)),
                          _createTextVNode(),
                          _hoisted_17
                        ]),
                        _createTextVNode(),
                        _hoisted_18
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_19,
                      _createTextVNode(),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_unref(Incorrect)),
                          _createTextVNode(),
                          _hoisted_21
                        ]),
                        _createTextVNode(),
                        _hoisted_22
                      ])
                    ], 64))
              ]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_25, _toDisplayString(currentQuestion.value.explanation.highlight), 1),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_26, _toDisplayString(currentQuestion.value.explanation.normal), 1)
              ])
            ])
          ]))
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_27, [
      (showsClickNextButton.value)
        ? (_openBlock(), _createBlock(AppButton, {
            key: 0,
            block: "",
            class: "button",
            onClick: onClickNext
          }, {
            default: _withCtx(() => [
              _createTextVNode("次の画面へ")
            ], undefined, true),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createTextVNode(),
      (showsBackToQuestionButton.value)
        ? (_openBlock(), _createBlock(AppButton, {
            key: 1,
            block: "",
            class: "button",
            onClick: onClickBackToQuestion
          }, {
            default: _withCtx(() => [
              _createTextVNode("問題へ戻る")
            ], undefined, true),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createTextVNode(),
      (showsYesNoButtons.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(AppButton, {
              block: "",
              class: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickYesNo('YES')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("YES")
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(AppButton, {
              block: "",
              class: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickYesNo('NO')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("NO")
              ], undefined, true),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})